<template>
  <Dialog v-bind="$attrs" v-on="$listeners">
    <template slot="title">
      <h2 class="el-dialog__title">{{ $attrs.title }}</h2>
    </template>
    <slot />
    <template slot="footer">
      <slot name="footer" />
    </template>
  </Dialog>
</template>

<script>
import { Dialog } from 'element-ui'

export default {
  name: 'BaseElDialog',
  components: { Dialog },
  inheritAttrs: false,
  data () {
    return {
      triggerElement: null
    }
  },
  watch: {
    '$attrs.visible' (newVal, oldVal) {
      if (newVal && !oldVal) {
        this.triggerElement = document.activeElement
      } else if (!newVal && oldVal && this.triggerElement) {
        const el = this.triggerElement
        this.triggerElement = null
        this.$nextTick(() => el.focus())
      }
    }
  }
}
</script>
